"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation deleteTag($tagId: String!) {
    deleteTag(tagId: $tagId)
  }
`;
exports.default = mutation;
//# sourceMappingURL=deleteTag.mutation.js.map